import { render } from "./CtaButton.vue?vue&type=template&id=611c2be0"
import script from "./CtaButton.vue?vue&type=script&lang=js"
export * from "./CtaButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/scripts/view/portfolio/sections/_helper/CtaButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "611c2be0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('611c2be0', __exports__)) {
    api.reload('611c2be0', __exports__)
  }
  
  module.hot.accept("./CtaButton.vue?vue&type=template&id=611c2be0", () => {
    api.rerender('611c2be0', render)
  })

}


export default __exports__